module.exports = __webpack_public_path__ + "static/media/lt_mob_r.419e2497.png";